'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeAuth = require('./KayleeAuth');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeRemoteControlSession = require('./KayleeRemoteControlSession');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeEquipmentTypes');
var sutl = require('../sutl/Sutl');

var KayleeRemoteControlSessions = {
    addRemoteControlSession: addRemoteControlSession,
    fromJson: fromJson,
    getRemoteControlSessions: getRemoteControlSessions,
    removeRemoteControlSession: removeRemoteControlSession,
};

// This function is called to add a temporary remote control session for an anonymous user or for
// a user that does not have helper permissions for the room being controlled. It should NOT be
// called for a user that has helper permissions on the room being controlled. It is expected that
// this function is only called by Jayne.

function addRemoteControlSession(roomId, sessionId, userId, expires, ipAddress, userAgent) {
    var indexPath = 'index/remoteControlSessionsByRoom/' + roomId;
    var updates = {};

    return KayleeBase.app.database().ref(indexPath).once('value')
    .then(function(snap) {
        // The current behavior is to only allow one anonymous remote control session per room. So,
        // first we delete any existing remote control sessions for the room.

        var sessionIds = Object.keys(snap.exists() ? snap.val() : {});
        var promises = [];

        for (var i = 0; i< sessionIds.length; i++) {
            /*jshint loopfunc: true */
            var sessionPath = 'remoteControlSessions/' + sessionIds[i];
            promises.push(
                KayleeBase.app.database().ref(sessionPath).once('value')
                .then(function(snap) {
                    if (!snap.exists()) return;

                    var session = snap.val();
                    updates['remoteControlSessions/' + snap.key] = null;
                    updates[
                        'index/remoteControlSessionsByRoom/' + session.roomId + '/' + snap.key
                    ] = null;

                    if (session.userId !== 'anonymousRemoteControl') {
                        updates['index/remoteControlSessionsByUser/' + session.userId] = null;
                    }
                })
            );
        }

        return Promise.all(promises);
    })
    .then(function() {
        // If this is an actual user (as opposed to the anonymous user), then we will need to load
        // the room so we can have the companyId and siteId to update the
        // remoteControlSessionsByUser index.

        if (userId === 'anonymousRemoteControl') return null;
        return KayleeUtil.loadRoomData({ roomId: roomId });
    })
    .then(function(obj) {
        // Add the new remote control session.

        var session = {
            expires: expires,
            ipAddress: ipAddress,
            roomId: roomId,
            userId: userId,
        };

        if (userAgent) session.userAgent = userAgent;

        updates['remoteControlSessions/' + sessionId] = session;
        updates['index/remoteControlSessionsByRoom/' + roomId + '/' + sessionId] = true;

        if (obj !== null) { // only for non-anonymous users with temporary permissions
            updates['index/remoteControlSessionsByUser/' + userId] = {
                companyId: obj.room.companyId,
                expires: expires,
                roomId: roomId,
                sessionId: sessionId,
                siteId: obj.room.siteId,
            };
        }

        return KayleeBase.update(updates);
    });
}

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseIndirectArray.$fromJson(data, 'RemoteControlSessions', reqProps, reqProps,
        function(data) {
            return getRemoteControlSessions(data.$roomId);
        }
    );
}

function getRemoteControlSessions(roomId) {
    var key = 'RemoteControlSessions: ' + roomId;
    var remoteControlSessions = KayleeCache.get(key);

    if (remoteControlSessions === null) {
        remoteControlSessions = new RemoteControlSessions(roomId);
        KayleeCache.put(key, remoteControlSessions);
    }

    return remoteControlSessions;
}

// This function removes (deactivates) a remote control session. It is expected that this function
// is only called by Jayne.

function removeRemoteControlSession(sessionId, session) {
    var updates = {};

    updates['remoteControlSessions/' + sessionId] = null;
    updates['index/remoteControlSessionsByRoom/' + session.roomId + '/' + sessionId] = null;

    if (session.userId !== 'anonymousRemoteControl') {
        updates['index/remoteControlSessionsByUser/' + session.userId] = null;
    }

    return KayleeBase.update(updates);
}

function RemoteControlSessions(roomId) {
    this.$roomId = roomId;
    var srcRef = KayleeBase.app.database().ref('index/remoteControlSessionsByRoom/' + roomId);
    this.$nodeType = 'remoteControlSessions';
    FirebaseIndirectArray.call(this, srcRef, KayleeRemoteControlSession.getSession);
    KayleeUtil.bindPrototypeMethods(RemoteControlSessions.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

RemoteControlSessions.prototype = Object.create(FirebaseIndirectArray.prototype);
RemoteControlSessions.prototype.constructor = RemoteControlSessions;

RemoteControlSessions.prototype.$toJson = function()  {
    return FirebaseIndirectArray.prototype.$toJson.call(this, [], { $roomId: this.$roomId });
};

RemoteControlSessions.prototype.$getThisSessionId = function() {
    var self = this;
    var fbUser = KayleeBase.app.auth().currentUser;

    if (KayleeAuth.isAuthenticatedAsAnonymousRemoteControl(fbUser)) {
        return fbUser.getIdTokenResult()
        .then(function(idTokenResult) {
            return sutl.getNode(idTokenResult, 'claims.sessionId');
        });
    } else if (KayleeAuth.isAuthenticatedAsUser(fbUser)) {
        var ref = KayleeBase.app.database().ref('/index/remoteControlSessionsByUser/' + fbUser.uid);
        KayleeUtil.loadData('sessions', {}, ref, false)
        .then(function(obj) {
            if (obj.sessions !== null) {
                for (var i = 0; i < self.$items.length; i++) {
                    var session = self.$items[i];

                    if (session.$id === obj.sessions.sessionId) {
                        return session.$id;
                    }
                }
            }

            return null;
        });
    }

    return Promise.resolve(null);
};

RemoteControlSessions.prototype.toString = function() {
    return '[Remote Control Sessions for ' + this.$roomId + ']';
};

module.exports = KayleeRemoteControlSessions;
